module.exports = __webpack_public_path__ + "static/img/SketchPngc9be23a64f538a5f437c33110300a2a48a5006714cc5a34ddd3bb74081cd3b74.1dc3cf45.png";